
import { css } from 'lit';
export default css`
.chip{
  display:inline-flex;
  align-items:center;
  gap:var(--spacing-2);
  transition:all ease-in 300ms;
  cursor:pointer;
  color:var(--neutral-charcoal);
  font-family:var(--ff-inter);
  text-decoration:none;
}

.chip--default,
.chip--link{
  border:2px solid var(--purple-indigo-light);
  border-radius:100px;
  padding:calc(var(--spacing-2) - 2px) var(--spacing-4);
  font-weight:var(--fw-medium);
  font-size:var(--fs-body-mobile);
  line-height:var(--lh-body-mobile);
}

.chip--default{
  background-color:none;
}

.chip--default:hover{
  background-color:var(--neutral-light);
}

.chip--default:hover pc-icon{
  flex-shrink:0;
  color:var(--purple-indigo);
}

.chip--default:focus{
  outline:none;
  border:2px solid var(--purple-indigo);
}

.chip--link{
  border:2px solid var(--purple-medium-neutral);
  background-color:var(--purple-medium-neutral);
}

.chip--link:hover{
  border:2px solid var(--purple-indigo);
  background-color:var(--purple-indigo);
  color:var(--primary-white);
}

.chip--link:focus{
  outline:none;
  border:2px solid var(--purple-indigo);
}

.chip--letter{
  justify-content:center;
  border-radius:var(--spacing-2);
  width:var(--spacing-8);
  height:var(--spacing-8);
  color:var(--primary-eggplant);
  font-size:var(--fs-h5-mobile);
  line-height:var(--lh-h5);
}

.facet-item__status.js-facet-deactivate{
  display:none;
}

pc-chip[active] .chip--letter,
.chip--letter:hover{
  background-color:var(--purple-indigo);
  color:var(--primary-white);
}

.chip--letter:focus{
  outline-color:var(--purple-indigo);
}

.chip--square-light,
.chip--square-dark{
  border-radius:var(--spacing-2);
  background-color:transparent;
  padding:calc(var(--spacing-2) - 2px) var(--spacing-4);
  font-weight:var(--fw-medium);
  font-size:var(--fs-body-mobile);
  line-height:var(--lh-body-mobile);
}

.chip--square-dark{
  border:2px solid var(--purple-indigo-light);
  color:var(--outline-white);
}

.chip--square-dark:focus,
  .chip--square-dark:hover{
    color:var(---purple-indigo);
    background-color:var(--outline-white);
  }

.chip--square-dark:focus{
    outline:2px solid var(--purple-indigo-light);
    outline-offset:2px;
  }

.chip--square-light{
  border:2px solid var(--purple-indigo);
  color:var(--purple-indigo);
}

.chip--square-light:focus,
  .chip--square-light:hover{
    color:var(--outline-white);
    background-color:var(--purple-indigo);
  }

.chip--square-light:focus{
    outline:2px solid var(--purple-indigo);
    outline-offset:2px;
  }

@media (min-width: 768px){
  .chip--default,
  .chip--link{
    cursor:pointer;
    font-size:var(--fs-body);
    line-height:var(--lh-body);
  }

  .chip--letter{
    font-size:var(--fs-h5);
  }
}
`;